import Vue from "vue";
import Router from "vue-router";
const router = Router;
Vue.use(router);
const other = "other";
const originalPush = router.prototype.push
router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
export default new router({
    routes: [
        { /* 首页 */
            path: '/',
            name: 'Index',
            alias: '/index',
            component: () => import("./views/pages/index/index.vue"),
            meta: {
                title: '联拓数科',
                content:{
                    keywords:'联拓数科,门店数字化',
                    description:'联拓数科,帮助您用更好的方法和工具助力门店数字化升级',
                },
            }
        },
        /* 支付产品 */
        { /* 支付产品概览 */
            path: '/payOverview',
            name: 'PayOverview',
            alias: '/payOverview',
            component: () => import("./views/pages/payOverview/payOverview.vue"),
            meta: {
                title: '联拓数科支付产品',
                content:{
                    keywords:'联拓数科,聚合支付,数字收银',
                    description:'联拓数科根据不同门店类型,推出适合门店业务发展的全系列支付商品',
                },
            }
        },
        { /* 收款小精灵 */
            path: '/payElves',
            name: 'PayElves',
            alias: '/payElves',
            component: () => import("./views/pages/payElves/payElves.vue"),
            meta: {
                title: '收款小精灵',
                content:{
                    keywords:'收款小精灵,收银黑科技,插件',
                    description:'联拓数科根据不同门店类型,推出适合门店业务发展的全系列支付商品',
                },
            }
        },
        { /* 数字前台 */
            path: '/payPos',
            name: 'PayPos',
            alias: '/payPos',
            component: () => import("./views/pages/payPos/payPos.vue"),
            meta: {
                title: '联拓数字前台',
                content:{
                    keywords:'数字前台,打通ERP',
                    description:'安全.快速.稳定的打通你的ERP数据',
                },
            }
        },
        { /* 小精灵PRO */
            path: '/paySoftware',
            name: 'PaySoftware',
            alias: '/paySoftware',
            component: () => import("./views/pages/paySoftware/paySoftware.vue"),
            meta: {
                title: '小精灵PRO',
                content:{
                    keywords:'小精灵PRO,细分软件',
                    description:'严选细分行业优秀软件,深度打通小精灵移动支付.卡券营销.企业钱包能力,输出对应软件的小精灵PRO版本',
                },
            }
        },
        { /* 收银硬件 */
            path: '/payHardware',
            name: 'PayHardware',
            alias: '/payHardware',
            component: () => import("./views/pages/payHardware/payHardware.vue"),
            meta: {
                title: '联拓收银硬件',
                content:{
                    keywords:'支付硬件,4G语音王,门店数字化指南',
                    description:'联拓的收银软件和插件已适配和多种不同场景.不同业务的硬件,便于商家轻松使用.快速收银',
                },
            }
        },
        { /* 小精灵商户通 */
            path: '/payMerchant',
            name: 'PayMerchant',
            alias: '/payMerchant',
            component: () => import("./views/pages/payMerchant/payMerchant.vue"),
            meta: {
                title: '小精灵商户通',
                content:{
                    keywords:'小精灵商户通,商户通APP',
                    description:'小精灵商户通APP是我们为商家量身打造的一款移动应用客户端。提供“支付+营销”一体化的智慧新零售移动工具。',
                },
            }
        },
        /* 私域会员产品概览 */
        { /* 私域会员产品概览 */
            path: '/digitalizeOverview',
            name: 'DigitalizeOverview',
            alias: '/digitalizeOverview',
            component: () => import("./views/pages/digitalizeOverview/digitalizeOverview.vue"),
            meta: {
                title: '私域会员产品概览',
                content:{
                    keywords:'数字商业,私域流量',
                    description:'联拓数科全系列的数字商业产品可以灵活运用在各种行业,助力商业构建自有私域流量，实现门店数字化升级。',
                },
            }
        },
        { /* 电子会员卡 */
            path: '/digitalizeCard',
            name: 'DigitalizeCard',
            alias: '/digitalizeCard',
            component: () => import("./views/pages/digitalizeCard/digitalizeCard.vue"),
            meta: {
                title: '电子会员卡',
                content:{
                    keywords:'电子会员，数字化运营',
                    description:'微信原生电子会员卡,可以轻量快速的切入到门店,高效精准的抓住每一个消费者,积累门店的私域流量,同时实现会员的精准标签,精准触达,精准营销。',
                },
            }
        },
        { /* 商家小程序 */
            path: '/digitalizeApplets',
            name: 'DigitalizeApplets',
            alias: '/digitalizeApplets',
            component: () => import("./views/pages/digitalizeApplets/digitalizeApplets.vue"),
            meta: {
                title: '商家小程序',
                content:{
                    keywords:'小程序，商城，外卖',
                    description:'真正实现用户支付和会员、线上和线下无缝连接的商户小程序，更好的帮助门店销售业绩增长，门店增长利器。',
                },
            }
        },
        { /* 商户管理后台 */
            path: '/digitalizeBackstage',
            name: 'DigitalizeBackstage',
            alias: '/digitalizeBackstage',
            component: () => import("./views/pages/digitalizeBackstage/digitalizeBackstage.vue"),
            meta: {
                title: '商户管理后台',
                content:{
                    keywords:'商户管理后台，精准营销，AI营销',
                    description:'联拓关注您的用户增长，并为之不断迭代可以促进拉新、复购、唤醒、提升客单价的各种工具能力，通过小精灵商户管理后台，您可以随着业务的发展，不断发挥创意去促进业绩的增长。',
                },
            }
        },
        /* 解决方案 */
		{ /* 7+N数字方案概览 */
            path: '/n7digitalOverview',
            name: 'N7digitalOverview',
            alias: '/n7digitalOverview',
            component: () => import("./views/pages/n7digitalOverview/n7digitalOverview.vue"),
            meta: {
                title: '7+N数字方案概览',
                content:{
                    keywords:'7+N数字方案概览',
                    description:'',
                },
            }
        },
		{ /* 数字零售方案 */
			path: '/digitalizeRetail',
			name: 'DigitalizeRetail',
			alias: '/digitalizeRetail',
			component: () => import("./views/pages/digitalizeRetail/digitalizeRetail.vue"),
			meta: {
				title: '数字零售方案',
				content:{
					keywords:'数字零售方案',
					description:'',
				},
			}
		},
		{ /* 数字餐饮方案 */
			path: '/digitalizeRestaurant',
			name: 'DigitalizeRestaurant',
			alias: '/digitalizeRestaurant',
			component: () => import("./views/pages/digitalizeRestaurant/digitalizeRestaurant.vue"),
			meta: {
				title: '数字餐饮方案',
				content:{
					keywords:'数字餐饮方案',
					description:'',
				},
			}
		},
		{ /* 优选营销方案 */
			path: '/marketingVersion',
			name: 'MarketingVersion',
			alias: '/marketingVersion',
			component: () => import("./views/pages/marketingVersion/marketingVersion.vue"),
			meta: {
				title: '优选营销方案',
				content:{
					keywords:'优选营销方案',
					description:'',
				},
			}
		},
		{ /* 高级营销方案 */
			path: '/advancedMarketing',
			name: 'AdvancedMarketing',
			alias: '/advancedMarketing',
			component: () => import("./views/pages/advancedMarketing/advancedMarketing.vue"),
			meta: {
				title: '高级营销方案',
				content:{
					keywords:'高级营销方案',
					description:'',
				},
			}
		},
		{ /* 数字商盟平台方案 */
			path: '/businessUnion',
			name: 'BusinessUnion',
			alias: '/businessUnion',
			component: () => import("./views/pages/businessUnion/businessUnion.vue"),
			meta: {
				title: '数字商盟平台方案',
				content:{
					keywords:'数字商盟平台方案',
					description:'',
				},
			}
		},
		{ /* 数字加油站方案 */
			path: '/gasStation',
			name: 'GasStation',
			alias: '/gasStation',
			component: () => import("./views/pages/gasStation/gasStation.vue"),
			meta: {
				title: '数字加油站方案',
				content:{
					keywords:'数字加油站方案',
					description:'',
				},
			}
		},
        { /* 轻会员营销 */
            path: '/lightMember',
            name: 'LightMember',
            alias: '/lightMember',
            component: () => import("./views/pages/lightMember/lightMember.vue"),
            meta: {
                title: '联拓轻会员',
                content:{
                    keywords:'轻会员，小精灵',
                    description:'小精灵营销推出的“轻会员”产品帮助小店打造属于自己的会员体系，玩转营销活动。小店用户也能领取电子会员卡，店主通过发放优惠券、充值有礼、付费会员等智能营销方式提高客单价，拉动储值现金流，实现盈利增长。',
                },
            }
        },
        /* 行业案例 */
        { /* 零售案例 */
            path: '/caseRetail',
            name: 'CaseRetail',
            alias: '/caseRetail',
            component: () => import("./views/pages/caseRetail/caseRetail.vue"),
            meta: {
                title: '数字零售',
                content:{
                    keywords:'数字零售，案例',
                    description:'从使用收款小精灵的第一个超市至今，从社区超市到购物广场，从母婴店到药店连锁，从店内到线上，我们为零售商户提供整合的数字解决方案',
                },
            }
        },
        { /* 餐饮案例 */
            path: '/caseRestaurant',
            name: 'CaseRestaurant',
            alias: '/caseRestaurant',
            component: () => import("./views/pages/caseRestaurant/caseRestaurant.vue"),
            meta: {
                title: '数字餐饮',
                content:{
                    keywords:'数字餐饮，案例',
                    description:'我们从餐饮门店的移动支付到扫码点餐，从升级电子化储值营销到自动化数据报表，从小程序外卖到多门店的管理平台，整体化赋能餐饮企业。',
                },
            }
        },
        { /* 加油站案例 */
            path: '/caseGas',
            name: 'CaseGas',
            alias: '/caseGas',
            component: () => import("./views/pages/caseGas/caseGas.vue"),
            meta: {
                title: '数字加油站',
                content:{
                    keywords:'数字加油站，案例',
                    description:'收款小精灵通过连接移动支付和会员营销，让加油站及其便利店更好地为顾客提供便捷的支付和高效通知，增强加油站用户的粘性。店主还可以通过线上引导提升非油业务收入，通过对会员和数据的高效运营，构建可自我成长的“人·车·生活”的生态圈。',
                },
            }
        },
        { /* 休闲娱乐案例 */
            path: '/caseAmusement',
            name: 'CaseAmusement',
            alias: '/caseAmusement',
            component: () => import("./views/pages/caseAmusement/caseAmusement.vue"),
            meta: {
                title: '数字泛行业',
                content:{
                    keywords:'数字泛行业，案例',
                    description:'收款小精灵为泛娱乐行业提供电子会员、线上商城小程序、计次卡、电子门票、在线预定、社群营销全线整合的数字解决方案。',
                },
            }
        },
        { /* 校园案例 */
            path: '/caseCampus',
            name: 'CaseCampus',
            alias: '/caseCampus',
            component: () => import("./views/pages/caseCampus/caseCampus.vue"),
            meta: {
                title: '数字校园',
                content:{
                    keywords:'数字校园，团餐，案例',
                    description:'收款小精灵通过校园专属硬件设备、结合在线储值、外卖商城在线购物、会员分层和管理，打通原有实体卡，实现校园一卡通，打造智慧校园。',
                },
            }
        },
        { /* 酒店案例 */
            path: '/caseHotel',
            name: 'CaseHotel',
            alias: '/caseHotel',
            component: () => import("./views/pages/caseHotel/caseHotel.vue"),
            meta: {
                title: '数字酒店',
                content:{
                    keywords:'数字酒店，案例',
                    description:'收款小精灵通过校园专属硬件设备、结合在线储值、外卖商城在线购物、会员分层和管理，打通原有实体卡，实现校园一卡通，打造智慧校园。',
                },
            }
        },
        /* 开放平台 */
        { /* 产品亮点 */
            path: '/productHighlights',
            name: 'ProductHighlights',
            alias: '/productHighlights',
            component: () => import("./views/pages/productHighlights/productHighlights.vue"),
            meta: {
                title: '联拓开放平台',
                content:{
                    keywords:'联拓数科，开放平台',
                    description:'联拓数科面向支付机构、软件厂商、集团性连锁、银行等客户，开放我们的一站式移动支付解决方案，让客户能够轻松构建自己的商业支付平台。',
                },
            }
        },
        /* 关于我们 */
        { /* 公司介绍 */
            path: '/lianTuoCompany',
            name: 'LianTuoCompany',
            alias: '/lianTuoCompany',
            component: () => import("./views/pages/lianTuoCompany/lianTuoCompany.vue"),
            meta: {
                title: '联拓数科企业介绍',
                content:{
                    keywords:'联拓数科，企业介绍',
                    description:'联拓数科用数字科技连接私域流量与线下商业，秉承联合比独立更有价值的理念，致力于推动中国线下商业数字化进程',
                },
            }
        },
        { /* 招纳贤才 */
            path: '/lianTuoRecruit',
            name: 'LianTuoRecruit',
            alias: '/lianTuoRecruit',
            component: () => import("./views/pages/lianTuoRecruit/lianTuoRecruit.vue"),
            meta: {
                title: '联拓数科招聘',
                content:{
                    keywords:'联拓数科，招聘',
                    description:'在联拓工作，不断创新 塑造未来。',
                },
            }
        },
        { /* 招纳贤才 */
            path: '/lianTuoRecruitInfo',
            name: 'LianTuoRecruitInfo',
            alias: '/lianTuoRecruitInfo',
            component: () => import("./views/pages/lianTuoRecruitInfo/lianTuoRecruitInfo.vue"),
            meta: {
                title: '联拓数科招聘',
                content:{
                    keywords:'联拓数科，招聘',
                    description:'在联拓工作，不断创新 塑造未来。',
                },
            }
        },
        { /* 在联拓面试 */
            path: '/lianTuoInterview',
            name: 'LianTuoInterview',
            alias: '/lianTuoInterview',
            component: () => import("./views/pages/lianTuoInterview/lianTuoInterview.vue"),
            meta: {
                title: '联拓数科面试',
                content:{
                    keywords:'联拓数科，面试',
                    description:'我们要寻找不一样的"你"，我们一直要寻找的是“热爱、好奇心、有目标”的你。',
                },
            }
        },
        { /* 在联拓成长 */
            path: '/lianTuoGrowUp',
            name: 'LianTuoGrowUp',
            alias: '/lianTuoGrowUp',
            component: () => import("./views/pages/lianTuoGrowUp/lianTuoGrowUp.vue"),
            meta: {
                title: '联拓数科工作',
                content:{
                    keywords:'联拓数科，员工成长',
                    description:'拼搏联拓人，我们希望你是有理想，有行动力，不断坚持，且追求卓越的你，希望和你一起开创出不一样的联拓，不一样的数字商业！',
                },
            }
        },
        { /* 在联拓生活 */
            path: '/lianTuoLife',
            name: 'LianTuoLife',
            alias: '/lianTuoLife',
            component: () => import("./views/pages/lianTuoLife/lianTuoLife.vue"),
            meta: {
                title: '联拓数科员工福利',
                content:{
                    keywords:'联拓数科，员工福利',
                    description:'网站描述：福利完善 · 快乐生活。联拓为所有员工提供完善的企业福利，打造轻松的工作环境，让你在充满激情的环境中工作，充满快乐的氛围中生活。',
                },
            }
        },
        { /* 活动与课程 */
            path: '/activityCurriculum',
            name: 'ActivityCurriculum',
            alias: '/activityCurriculum',
            component: () => import("./views/pages/activityCurriculum/activityCurriculum.vue"),
            meta: {
                title: '联拓数科市场动态与培训课程',
                content:{
                    keywords:'市场动态，培训课程',
                    description:'了解联拓的市场动态，并了解我们如何帮助您的业务，我们将定期举办活动，与像您这样的经营者交谈。我们还有完善的课程，帮助您更好的发展团队、服务商家。',
                },
            }
        },
        { /* 404页面 */
            path: '/404',
            name: '404',
            alias: '/' + other + '/404',
            component: () => import("./views/other/404.vue"),
            meta: {
                title: 'Sorry,The page you visited does not exist'
            }
        },
        { /* 404路由，无效路由跳转404，必须是最后一个路由 */
            path: '*',
            redirect: '/404'
        }
    ],
    mode: 'hash'
});
